import axios from 'axios';

/**
 * @description 파일 업로드 Binary
 * @param {*} formData
 * @returns Promise
 */
const uploadChosenFileApi = async (formData = new FormData()) => {
  return await axios.post(`/api/brand/uploadChosenVoiceRecFile`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

/**
 * @description 파일명 입력
 * @param {*} corpId 법인ID
 * @param {*} brandId 브랜드ID
 * @param {*} soundTitle 파일명
 * @param {*} fileOnServer 파일경로
 * @param {*} playtime 재생시간
 * @returns
 */
const registMySoundByFileApi = async (corpId = null, brandId = null, soundTitle = null, tempNo = null, playtime = 0) => {
  return await axios.post(`/api/brand/registMySoundByVoiceRecFile`, {
    corpId,
    brandId,
    soundTitle,
    tempNo,
    playtime,
  });
};

/**
 * @description AI 보이스 템플릿 가져오기
 * @param {*} param
 * @returns
 */
const getVoiceTemplateListApi = param => {
  return axios.post(`/api/brand/v2/getVoiceTemplateList`, param);
};
/**
 * @description AI 보이스 옵션 조회
 * @param {*} param
 */
const getVoiceOptionListApi = param => {
  return axios.post(`/api/brand/v2/getVoiceOptionList`, param);
};
/**
 * @description AI 보이스(TTS) 파일 생성
 * @param {*} param
 */
const listenTextPreviouslyApi = param => {
  return axios.post(`/api/brand/v2/listenTextPreviously`, param);
};
/**
 * @description TTS 미리듣기
 * @param {*} param
 */
const downloadTTSFileApi = param => {
  return axios.post(`/api/brand/downloadTTSFile`, param);
};
export { uploadChosenFileApi, registMySoundByFileApi, getVoiceTemplateListApi, getVoiceOptionListApi, listenTextPreviouslyApi, downloadTTSFileApi };
